export const DURATION = 750;
export const LEGEND_ITEM_RADIUS = 6;

export const colors = {
  blue: 'rgb(31, 119, 180)',
  green: '#80BF34',
  red: 'rgb(214, 39, 40)',
  lightblue: 'lightblue',
  darkblue: 'rgb(31, 119, 180)',
  gray: 'gray',
  pro: 'rgb(15, 140, 121)',
  con: 'rgb(189, 45, 40)',
  lightgray: '#ddd'
}

export const closest = (num, arr) => {
  let curr = arr[0]
  let currIndex = 0;
  for (let index = 0; index < arr.length; index++) {
    if (Math.abs(num - arr[index]) < Math.abs(num - curr)) {
      curr = arr[index];
      currIndex = index;
    }
  }

  return { curr, currIndex }
}

export const getSVGPosition = (element) => {
  const matrix = element.getScreenCTM();

  return [matrix.e + window.pageXOffset, matrix.f + window.pageYOffset];
}



// WEBPACK FOOTER //
// ./src/charts/utils.js